import { connect } from "react-redux";
import ClientsList from "./ClientsList";

import { init, getReferentielsList } from 'redux/actions/referentielsActions';

const mapStateToProps = (state, ownProps) => {
	return {
		clientsList: state.clients.clientsList,
		page: state.clients.page,
		pages: state.clients.pages,
		pageSize: state.clients.pageSize,
		nbItems: state.clients.clientsList.length,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		init: sectionName => dispatch(init(sectionName)),
		getNext: page => {
			const nextPage = page;
			
			dispatch(getReferentielsList({ page: nextPage }, "clients"));
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(ClientsList);


// WEBPACK FOOTER //
// src/containers/admin/clients/ClientsContainer.js